<template>
  <MenuPopover
    class="TagCombine"
    trigger="click"
    placement="bottom"
    :offset="{ y: 5 }"
    popover-class="popover-default tag-combine-popover"
    :label="count ? $t('tags.combine_count', { count }) : $t('tags.combine')"
    :items="[{ key: 'form', slot: 'form' }]"
    @show="reset"
  >
    <template #trigger>
      <FAIcon
        icon="sliders"
        fixed-width
      />
      <span
        v-if="count"
        class="tag-combine-count badge -neutral"
      >{{ count }}</span>
    </template>
    <template #form>
      <form
        class="tag-combine-form"
        @submit.prevent="apply"
      >
        <label
          v-for="kind in kinds"
          :key="kind"
        >
          {{ $t(`tags.combine_${kind}`) }}
          <input
            v-model="form[kind]"
            class="input"
            type="text"
            :placeholder="$t('tags.combine_placeholder')"
          >
        </label>
        <div class="tag-combine-actions">
          <button
            class="btn button-default -primary"
            type="submit"
          >
            {{ $t('tags.combine_apply') }}
          </button>
          <button
            v-if="count"
            class="btn button-default"
            type="button"
            @click="clear"
          >
            {{ $t('tags.combine_clear') }}
          </button>
        </div>
      </form>
    </template>
  </MenuPopover>
</template>

<script>
import MenuPopover from 'src/components/menu_popover/menu_popover.vue'

import { parseTagArgument, tagList } from 'src/services/tag_query/tag_query.js'

const KINDS = ['any', 'all', 'none']

// Combine a hashtag timeline with other tags: any of them, all of them,
// none of them. The choice lives in the address.
export default {
  components: { MenuPopover },
  props: {
    // the timeline's tag argument, see tag_query
    argument: { type: String, required: true },
  },
  data: () => ({
    form: { any: '', all: '', none: '' },
  }),
  computed: {
    kinds() {
      return KINDS
    },
    parsed() {
      return parseTagArgument(this.argument)
    },
    count() {
      return KINDS.reduce((sum, kind) => sum + this.parsed[kind].length, 0)
    },
  },
  created() {
    this.reset()
  },
  methods: {
    reset() {
      this.form = Object.fromEntries(
        KINDS.map((kind) => [kind, this.parsed[kind].join(', ')]),
      )
    },
    go(query) {
      this.$router.push({
        name: 'tag-timeline',
        params: { id: this.parsed.tag },
        query,
      })
    },
    apply() {
      const query = {}
      for (const kind of KINDS) {
        const tags = tagList(this.form[kind])
        if (tags.length) query[kind] = tags.join(',')
      }
      this.go(query)
    },
    clear() {
      this.go({})
    },
  },
}
</script>

<style lang="scss">
.TagCombine > .popover-trigger-button {
  display: inline-flex;
  align-items: center;
  gap: 0.2em;
}

.tag-combine-form {
  display: flex;
  flex-direction: column;
  gap: 0.6em;
  padding: 0.6em 0.8em;
  min-width: 16em;

  label {
    display: flex;
    flex-direction: column;
    gap: 0.2em;
  }

  .tag-combine-actions {
    display: flex;
    gap: 0.5em;
  }
}
</style>
